import { doc, setDoc, getFirestore } from "firebase/firestore";
import { FirestoreToken } from "../types/FirestoreToken";

async function updateTokenData(id: string, data: Partial<FirestoreToken>): Promise<void> {
  const docRef = doc(getFirestore(), "tokens", id);
  await setDoc(docRef, data, { merge: true });
}

export default updateTokenData;
